import React from 'react';

function Header(props) {
  let organiser = props.participants.find((participant) => {
    return participant.organiser;
  });

  let subtitle;

  switch (props.participants.length) {
    case 1:
      subtitle = organiser.name + " created this invite to go out.";
      break;
    case 2:
      subtitle = organiser.name + " and another friend are going out.";
      break;
    default:
      subtitle =  organiser.name + " and a couple of friends are going out.";
      break;
  }

  return (
    <React.Fragment>
      <h1>Let's go out!</h1>
      <h2>{subtitle}</h2>
    </React.Fragment>
  );
}

export default Header;
